import React, { useEffect, useState } from "react";
import { apis, patch } from "../../Utils/axios";
import { Button, Form, Modal, Toast, Input } from "..";
import { formatDobInput, parseDobInput } from "../../Utils/dob";
import moment from "moment";
import { TbCalendar } from "react-icons/tb";

function EditDob({ dob, reload }) {
	const [open, setOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const [input, setInput] = useState(dob ? moment(dob).format("DD/MM/YYYY") : "");

	useEffect(() => {
		setInput(dob ? moment(dob).format("DD/MM/YYYY") : "");
	}, [dob]);

	const initialInput = dob ? moment(dob).format("DD/MM/YYYY") : "";
	const hasChanges = input !== initialInput;

	const onSubmit = () => {
		if (!input) {
			return Toast.error("Please enter date of birth");
		}
		const parsed = parseDobInput(input);
		if (parsed.error) {
			return Toast.error(parsed.error);
		}
		// Backend expects YYYY-MM-DD format string for DOB
		const dobDate = moment(parsed.value).format("YYYY-MM-DD");
		setLoading(true);
		patch(
			apis.updateMyProfile,
			{
				dob: dobDate,
			},
			(r, e) => {
				setLoading(false);
				if (r) {
					if (typeof reload === "function") {
						reload();
					}
					Toast.success("Date of birth updated");
					setOpen(false);
				} else if (e) {
					Toast.handleError(e);
				}
			}
		);
	};

	return (
		<>
			<Button onClick={() => setOpen(true)} variant="outlined" className="btn-xs">
				<TbCalendar className="mr-2" />
				{dob ? moment(dob).format("DD/MM/YYYY") : "Add Date of Birth"}
			</Button>
			<Modal open={open} onClose={() => setOpen(false)} contentClass="w-[95vw] max-w-[28rem]">
				<div className="p-4 sm:p-6 md:p-8">
					<h1 className="text-xl sm:text-2xl font-bold pr-10">Date of Birth</h1>
			<Form onSubmit={onSubmit} className="mt-4 space-y-4">
						<Input
							value={input}
							onChange={(value) => {
								// When typing forward, auto-insert slashes (01/01/2021)
								// but avoid fighting the cursor when editing in the middle.
								if (!value) {
									setInput("");
									return;
								}
								const was = input || "";
								const addingAtEnd = value.length >= was.length && value.startsWith(was);
								setInput(addingAtEnd ? formatDobInput(value) : value);
							}}
							onBlur={() => {
								if (!input) return;
								// Normalize any partially formatted value on blur
								setInput(formatDobInput(input));
							}}
							placeholder="DD/MM/YYYY"
							maxLength={10}
							allowSpecialChars
							label="Date of Birth"
							inputClass="tracking-wide"
						/>
						{hasChanges && (
							<Button loading={loading} type="submit" className="w-full">
								Save
							</Button>
						)}
					</Form>
				</div>
			</Modal>
		</>
	);
}

export default EditDob;

